import { useEffect, useRef } from 'react';
import { useGame } from '../state/SocketProvider';
import { Contours } from '../ui/Contours';
import { setupStore } from '../state/setup';

const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()));

/** v11 §2H (BOLT-028): the standalone first-hider screen is GONE — the host
 *  pre-selected the choice in the lobby, and this transient view auto-sends
 *  `choose_first_hider` the moment the phase opens (the wire is unchanged;
 *  the server's firsthider phase stays). Players see it for a beat at most. */
export function FirstHider() {
  const { state, send, status } = useGame();
  const sent = useRef(false);
  const isHost = state?.you.isHost ?? false;
  const phase = state?.phase;
  useEffect(() => {
    // v12.2 field fix: send() drops silently unless the socket is OPEN, and a
    // latched once-ref then hangs the whole room in firsthider. Re-arm on
    // every reconnect — the rejoin re-delivers this phase, so the send
    // re-fires until the server advances the round.
    if (status !== 'open') {
      sent.current = false;
      return;
    }
    if (phase !== 'firsthider' || !isHost || sent.current) return;
    sent.current = true;
    send({ t: 'choose_first_hider', team: setupStore.get(), idem: uuid() });
  }, [phase, isHost, status, send]);
  if (!state) return null;

  return (
    <div className="screen">
      <Contours />
      <div className="screen__inner">
        <div className="eyebrow score-eyebrow">First hider · {state.code}</div>
        <div className="lobby-title">
          Starting <em>the game…</em>
        </div>
        <div className="eyebrow" style={{ textAlign: 'center', marginTop: '2rem' }} data-testid="firsthider-wait">
          {isHost ? 'Locking in the first hider…' : 'Waiting for the host…'}
        </div>
      </div>
    </div>
  );
}
